export default __webpack_public_path__ + "static/card-img01-81421d84db4f653e765b1dd8115075b5.jpg";